<template>
  <section class="max-w-screen-xl mx-auto px-4 pb-20 max-md:pb-10 relative z-10 [&_p]:leading-8 [&_p]:tracking-wider">
    <h2 class="text-center">
      <WrGradientText text="Terms and Conditions"
        append-class="pb-0 pt-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_35.57%,_var(--text-gradient-2)_55.72%)]" />
    </h2>
  </section>
  <section class="py-12 max-sm:pt-0 relative z-10 [&_p]:leading-8 [&_p]:tracking-wider">
    <div class="flex flex-col items-start justify-center w-full px-10 max-w-screen-xl mx-auto relative z-10">
      <h3 class="mt-5 text-[22px] max-md:text-base font-bold">
        General Terms & Conditions:
      </h3>
      <h3 class="mt-5 text-lg max-md:text-base font-bold">
        Terms of services:
      </h3>
      <p class="text-lg max-md:text-sm mt-5">
        WebReinvent presents a legal agreement, which demonstrates 100%
        assurance of abiding by (NDA) Non-Disclosure Agreement Guarantee to stop
        infringement of "Confidential Information" of clients. We guarantee to
        use the provided information unbiasedly and protect it from any sort of
        misuse from other clients or resources
      </p>
      <h3 class="mt-5 text-lg max-md:text-base font-bold">Introduction:</h3>
      <p class="mt-5 text-lg max-md:text-sm">
        Capitalized terms, unless otherwise defined, have the meaning specified
        within the Definitions section below. This Terms, along with our Privacy
        Policy, any mobile license agreement, and other posted guidelines within
        our Website, collectively "Legal Terms", constitute the entire and only
        agreement between you and WebReinvent, and supersede all other
        agreements, representations, warranties and understandings with respect
        to our Website and the subject matter contained herein. We may amend our
        Legal Terms at any time without specific notice to you.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        The latest copies of our Legal Terms will be posted on our Website, and
        you should review all Legal Terms prior to using our Website. After any
        revisions to our Legal Terms are posted, you agree to be bound to any
        such changes to them. Therefore, it is important for you to periodically
        review our Legal Terms to make sure you still agree to them.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        By using our Website, you agree to fully comply with and be bound by our
        Legal Terms. Please review them carefully. If you do not accept our
        Legal Terms, do not access and use our Website. If you have already
        accessed our Website and do not accept our Legal Terms, you should
        immediately discontinue use of our Website.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        The last update to our Terms & Conditions was posted on September 14,
        2010.
      </p>
      <h3 class="mt-5 text-lg max-md:text-base font-bold">Definition:</h3>
      <p class="mt-5 text-lg max-md:text-sm">
        The terms "us" or "we" or "our" refers to WebReinvent the owner of the
        Website.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        A "Visitor" is someone who merely browses our Website, but has not
        registered as a Member.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        A "Member" is an individual that has registered with us to use our
        Service.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Our "Service" represents the collective functionality and features as
        offered through our Website to our Members.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        A "User" is a collective identifier that refers to either a Visitor or a
        Member.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        All text, information, graphics, audio, video, and data offered through
        our Website are collectively known as our "Content".
      </p>
      <h3 class="mt-5 text-lg max-md:text-base font-bold">
        Links to Other Websites:
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        Our Website may contain links to third party websites. These links are
        provided solely as a convenience to you. By linking to these websites,
        we do not create or have an affiliation with, or sponsor such third
        party websites. The inclusion of links within our Website does not
        constitute any endorsement, guarantee, warranty, or recommendation of
        such third party websites. WebReinvent has no control over the legal
        documents and privacy practices of third party websites; as such, you
        access any such third party websites at your own risk.
      </p>
      <h3 class="mt-5 text-lg max-md:text-base font-bold">Legal Compliance:</h3>
      <p class="mt-5 text-lg max-md:text-sm">
        You agree to comply with all applicable domestic and international laws,
        statutes, ordinances, and regulations regarding your use of our Website.
        WebReinvent reserves the right to investigate complaints or reported
        violations of our Legal Terms and to take any action we deem
        appropriate, including but not limited to canceling your Member account,
        reporting any suspected unlawful activity to law enforcement officials,
        regulators, or other third parties and disclosing any information
        necessary or appropriate to such persons or entities relating to your
        profile, email addresses, usage history, posted materials, IP addresses
        and traffic information, as allowed under our Privacy Policy.
      </p>

      <h3 class="mt-5 text-lg max-md:text-base font-bold">
        Other Terms and Conditions:
      </h3>
      <ul class="mt-5 text-lg max-md:text-sm list-[disc] pl-8 ml-8">
        <li v-for="item in otherTnC" class="mt-2 leading-8" v-html="item"></li>
      </ul>


      <h3 class="mt-5 text-lg max-md:text-base font-bold">
        Cancellation Policy
      </h3>
      <p class="mt-5 text-lg max-md:text-base font-bold">
        WebReinvent follows a transparent and no confusion cancellation policy.
        Here are the terms of the policy:
      </p>
      <ul class="mt-5 text-lg max-md:text-sm list-[disc] pl-8 ml-8 ">
        <li v-for="item in CancellationPolicyitems" class="mt-2 leading-8">{{ item }}</li>
      </ul>

      <h3 class="mt-5 text-lg max-md:text-base font-bold">Refund Policy</h3>
      <p class="mt-5 text-lg max-md:text-sm">
        Due to the nature of its services, WebReinvent does not guarantee any
        refunds upon cancellation. In case of monthly payment, only after
        reviewing the current month’s performance the payment for next month
        will be released. WebReinvent will not be held responsible for any
        refund claims thereof and does not make any guarantees on the basis of
        traffic & rankings etc.
      </p>
      <h3 class="mt-5 text-lg max-md:text-base font-bold">Law and Jurisdiction:

      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        The terms and conditions of this Policy shall be governed by Indian Laws, and the courts in DELHI, shall only
        have exclusive jurisdiction to resolve/ adjudicate upon any disputes.
     </p>
      <h3 class="mt-5 text-lg max-md:text-base font-bold">
        Intellectual Property Rights:
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        The contents of these pages are Copyright © 2021 WebReinvent
      </p>

      <p class="mt-5 text-lg max-md:text-sm">
        We are the owner or the licensee of all intellectual property rights in
        our Website, and in the images and other material published on it (the
        ‘Content’). The Content is protected by copyright laws and treaties
        around the world. All such rights are reserved.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        You may print off one copy, and may download extracts of any page(s)
        from our Website for your personal reference and you may draw the
        attention of others within your organization to material posted on our
        Website.
      </p>

      <p class="mt-5 text-lg max-md:text-sm">
        You must not modify the paper or digital copies of any materials you
        have printed off or downloaded in any way, and you must not use any
        illustrations, photographs, video or audio sequences or any graphics
        separately from any accompanying text.
      </p>

      <p class="mt-5 text-lg max-md:text-sm">
        Our status (and that of any identified contributors) such as the authors
        of Content on our website must always be acknowledged.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        You must not use any part of the materials on our Website for commercial
        purposes without obtaining a license to do so from us or our licensors.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        IF YOU PRINT OFF, COPY OR DOWNLOAD ANY PART OF OUR WEBSITE IN BREACH OF
        THESE TERMS OF USE, YOUR RIGHT TO USE OUR WEBSITE WILL CEASE IMMEDIATELY
        AND YOU MUST, AT OUR OPTION, RETURN OR DESTROY ANY COPIES OF THE
        MATERIALS YOU HAVE MADE.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        If you have any concerns about material which appears on our Website,
        please contact
        <a href="mailto:we@webreinvent.com" class="underline break-all hover:text-[#5f4ca4]">we@webreinvent.com</a>
        Thank you for visiting our Website.
      </p>
    </div>
  </section>

  <section
    class="relative pt-10 lg:pt-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20 [&_p]:leading-8 [&_p]:tracking-wider">
    <h2 class="text-center mb-11">
      <WrGradientText text="Trusted for excellence and efficiency" />
      <p class="text-lg max-md:text-sm text-[var(--foreground)] font-anvtgrade-book">
        Webreinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </p>
    </h2>
    <!-- Carousel Section -->
    <WrTestimonialCardCarousel />
    <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7">View All</WrButton>
  </section>
</template>

<script setup>
useHead({
  title: "Software Products, Web and Mobile App Development Company",
  meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    { name: "description", content: "" },
    { name: "twitter:card", content: "summary" },
    { name: "twitter:site", content: "@weinvent" },
    { name: "twitter:creator", content: "@weinvent" },
    {
      property: "og:title",
      content: "Software Products, Web and Mobile App Development Company",
    },
    { property: "og:description", content: "" },
    {
      property: "og:image",
      content: "https://webreinvent.com/images/social-sharing.webp",
    },
    {
      property: "og:image:secure_url",
      content: "https://webreinvent.com/images/social-sharing.webp",
    },
    { property: "og:image:alt", content: "WebReinvent" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://webreinvent.com" },
    { property: "og:site_name", content: "WebReinvent" },
    { property: "fb:admins", content: "204425406249172" },
  ],
});

const otherTnC = ref([
  "Amounts written in the estimation are excluding GST (Goods & Services Tax) or any other taxes applicable.",
  "All the payments are considered as non-refundable.",
  "Any work or task which is not written in this estimation will be charged additional on hourly basis e.g. creating email accounts, uploading files, updating images or content, adding new products, creating video tutorials, technical documentation, git repo backup etc.",
  "Documents/files like database structure, raw files like PSD, HTML, user flow diagram etc will be charged additional.",
  "We expect payment as per the due date of each invoice.",
  "In any case, if the due date of an invoice is not written, then consider the due date as immediate and if an invoice is overdue for more than 10 days, then WebReinvent reserves the right to stop working without any further communication or may impose a penalty.",
  "If WebReinvent doesn't get the final payment within 30 days from completion of the project or in case of no response from the client for 30 days, WebReinvent reserves the right to sell the entire work to a third party to recover the expense even if we are under NDA contract.",
  "If the client wishes to cancel the project at any point in time during the process, then they shall remain liable to pay for the hours invested or the work completed and shall be invoiced accordingly.",
  "An advance fee is required, as agreed, before work can start. Clients should only pay this advance fee if they agree to our Terms and Conditions.",
  "<b>Billable Hours:</b> Hour will be billable for the time invested in code/documentation/guideline study or review, meetings, phone calls, tasks, chats etc.",
  "If any third party tool/extension/plugin/application is used or required in the system/website/application, and if the tool/extension/plugin/application is a paid version (not free), then the license will be purchased by the client and then given to us for its implementation and we can't determine such instance at the time of estimation.",
  "In case of no response received for 30 days regarding payment or approval or tasks then reserve the right to close the project without any refund.",
  "One page will be considered of 1200 pixel height, if it exceeds then that will be considered as 2 pages.",
  "Our charges are only for our services and it does not include the cost of any paid tool or other service.",
  "If an understanding of code is required, charges will incur.",
  "The images that we will use on the site will be dummy stock images and we recommend you to buy these images so you hold the copyright to use these images. Our quote does not include the pricing of these images.",
  'You should check the "time and expense" tab on a daily basis for time logs. For any concerns, please raise your concern immediately on the task.',
  "When purchasing any of our packages, please remember that the unused hours will not roll over to the next month.",
  "For all Indian Clients, 18% GST will be applicable. GST number 07AABCW3001D1Z0",
  "No documentation of the project is included in the work of scope if it's not written in the estimation items. Only wireframes, UI Designs, HTML, files and database are deliverables if written",
  "Once the software/web/mobile app is delivered, we are not responsible for the backup.",
  "Our software does not support any version of Internet Explorer (IE).",
]);

const CancellationPolicyitems = ref([
  " Our billing department will handle all the cancellation requests and it should be sent or communicated to your Account Manager. The cancellation will not be valid until it is confirmed by the particular department.",
  "If the cancellation request is made within 12 hours of placing the order and execution of the project has not started already then only it will be considered.",
  "WebReinvent will not be held responsible for any third party services, such as hosting, web development, content writing etc.",
]);
</script>
